import { Injectable } from '@angular/core';
import { Lambda } from 'aws-sdk';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class TelecomService {

  unspecifiedErrorMessage: string = "An error occurred. please contact technical support."
  lobList = [];
  languages = [];
  
  constructor(){
    this.getLOBs().then((resultData:any)=>{
      console.log("get lob result: ", resultData);
      this.lobList = resultData.lobList;
    });
    this.getLanguages().then((resultData:any)=>{
      console.log("get language result: ", resultData);
      this.languages = resultData.languages;
    });
  }

  getLOBs(){
    return new Promise(resolve =>{
      let lobList = [];
      let error = false;
      let message = "";
      this.applicationDataLambda("get", "LOBList").then(data=>{
        if(data.status == 200){
          lobList = data['data'][0]['data'];
          resolve({"lobList": lobList,"error": error,"message": message});
        }else{
          console.error(data)
          message = data.message;
          error = true;
          resolve({"lobList": lobList,"error": error,"message": message});
        }
      }, err=>{
        console.error(err)
        message = "Failed to retrieve application data."
        error = true;
        resolve({"lobList": lobList,"error": error,"message": message});
      });
    });
  }

  getLanguages(){
    return new Promise(resolve =>{
      let languages = [];
      let error = false;
      let message = "";
      this.applicationDataLambda("get", "languageList").then(data=>{
        if(data.status == 200){
          languages = data['data'][0]['data'];
          resolve({"languages": languages,"error": error,"message": message});
        }else{
          console.error(data)
          message = data.message;
          error = true;
          resolve({"languages": languages,"error": error,"message": message});
        }
      }, err=>{
        console.error(err)
        message = "Failed to retrieve application data."
        error = true;
        resolve({"languages": languages,"error": error,"message": message});
      });
    });
  }

  applicationDataLambda(op, _collection="", _key=""): Promise<any>{
    let lambda = new Lambda();
    let params = {
      FunctionName: environment.ApplicationDataLambdaName,
      Payload: JSON.stringify({
        operation: op,
        collection: _collection,
        key: _key
      })
    }
    return new Promise((resolve, reject) => {
      lambda.invoke(params, (err, data) => {
        if (err) {
          console.error('APP DATA ERROR: ', err);
          reject(err);
        } else {
          let response = (data as any);
          let payload = JSON.parse(response.Payload);
          console.log(response)
          console.log(payload)
          resolve(payload);
        }
      });
    });
  }

  /**Standardized lambda calls. always resolve payload even if present */

  getRows(lambdaName:string, args = {}): Promise<any>{
    let lambda = new Lambda();
    let payload = Object.assign({}, {operation: 'get'}, args);

    let params = {
      FunctionName: lambdaName,
      Payload: JSON.stringify(payload)
    }
    const promise = new Promise((resolve, reject) => {
      lambda.invoke(params, (err, data) => {
        if (err) {
          console.error('An error occurred while trying to retrieve data:', err);
          reject(err);
        } else {
          let response = (data as any);
          let payload = JSON.parse(response.Payload);
          console.log(payload);
          resolve(payload);
        }
      });
    });
    return promise;
  }

  saveRow(row, lambdaName:string): Promise<any>{
    let lambda = new Lambda();
    let params = {
      FunctionName: lambdaName,
      Payload: JSON.stringify({
        operation: row.action,
        data: row.item
      })
    }
    console.log(params);
    const promise = new Promise((resolve, reject) => {
      lambda.invoke(params, (err, data) => {
        if (err) {
          console.error('An error occurred while trying to save data:', err);
          reject(err);
        } else {
          let response = (data as any);

          let payload = JSON.parse(response.Payload);
          console.log(payload);
          resolve(payload);
        }
      });
    });
    return promise;
  }

  callLambda(params: any, errorMessage: string ): Promise<any>{
    let lambda = new Lambda();
    const promise = new Promise((resolve, reject) => {
      lambda.invoke(params, (err, data) => {
        if (err) {
          console.error(errorMessage, err);
          reject(err);
        } else {
          let response = (data as any);
          let payload = JSON.parse(response.Payload);
          console.log(payload);
          resolve(payload);
        }
      });
    });
    return promise;
  }

  getQueues(): Promise<any>{
    let lambda = new Lambda();
    let params = {
      FunctionName: environment.QueuesLambdaName,
      Payload: JSON.stringify({
        operation: 'get'
      })
    }
    const promise = new Promise((resolve, reject) => {
      lambda.invoke(params, (err, data:any) => {
        if (err) {
          console.error('An error occurred while retrieving languages:', err);
          reject(this.unspecifiedErrorMessage);
        } else {
          console.log("getQueues: ", data)
          let payload = JSON.parse(data.Payload);
          if(payload.statusCode == 200){
            console.log(payload);
            resolve(payload.body.queueList);
          }else{
            console.error("received unexpected status code");
            reject(payload.Error);
          }
        }
      });
    });
    return promise;
  }

}